/**
 * Страница сброса пароля по токену.
 */

import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { authAPI } from '../../api/client';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const token = searchParams.get('token') || '';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');

    if (password !== confirm) {
      setMessage('Пароли не совпадают');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.resetPassword(token, password);
      setMessage(res.data.message);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err: any) {
      setMessage(err.response?.data?.error || 'Ошибка сброса пароля');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.title}>Ошибка</h1>
          <p style={{ textAlign: 'center', color: '#6b7280' }}>
            Токен сброса не найден. <Link to="/forgot-password">Запросить новый</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Новый пароль</h1>

        <form onSubmit={handleSubmit}>
          {message && (
            <div style={{
              ...styles.message,
              backgroundColor: message.includes('сброшен') ? '#f0fdf4' : '#fef2f2',
              color: message.includes('сброшен') ? '#166534' : '#dc2626',
            }}>
              {message}
            </div>
          )}

          <div style={styles.field}>
            <input
              type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              placeholder="Новый пароль (мин. 8, A-Z, a-z, 0-9)" required minLength={8}
            />
          </div>
          <div style={styles.field}>
            <input
              type="password" value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              style={styles.input}
              placeholder="Подтвердите пароль" required
            />
          </div>

          <button type="submit" style={styles.button} disabled={loading}>
            {loading ? 'Сброс...' : 'Сбросить пароль'}
          </button>
        </form>

        <p style={styles.link}>
          <Link to="/login">Вернуться к входу</Link>
        </p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    minHeight: '100vh', backgroundColor: 'var(--bg-body)',
  },
  card: {
    backgroundColor: 'var(--bg-card)', padding: 40, borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', width: 400, maxWidth: '90vw',
  },
  title: { textAlign: 'center', color: '#2563eb', marginBottom: 24, fontSize: 24 },
  message: { padding: '10px 14px', borderRadius: 8, marginBottom: 16, fontSize: 14 },
  field: { marginBottom: 16 },
  input: {
    width: '100%', padding: '10px 14px', border: '1px solid var(--border-color)',
    borderRadius: 8, fontSize: 15, boxSizing: 'border-box' as const,
  },
  button: {
    width: '100%', padding: '12px', backgroundColor: '#2563eb', color: '#fff',
    border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer',
  },
  link: { textAlign: 'center', marginTop: 16, fontSize: 14, color: 'var(--text-secondary)' },
};

export default ResetPasswordPage;
